class MedicamentoConfiguracaoAnvisaController extends AbstractCrudController

  configure: (configs) ->
    configs.model = 'medicamentoConfiguracaoAnvisa'
    configs.module = 'eficiencia-fiscal'
    configs.folder = 'configuracao/icms/desvios-st/tabs/farmaceutico/configuracoes-anvisa'

    configs.itemName = (config) -> "a configuração da ANVISA para o estado de #{config.estado.nome}"

  initialize: ->
    @inject('estadoService')

    @listOfEstado = []
    @loadingTracker.addPromise @estadoService.getList((list)=>
      @listOfEstado = ({id: estado.id, nome: estado.nome} for estado in list)
    )

    @listOfColuna = [
      {id: 'pmc0', nome: 'PMC 0%'}
      {id: 'pmc12', nome: 'PMC 12%'}
      {id: 'pmc17', nome: 'PMC 17%'}
      {id: 'pmc18', nome: 'PMC 18%'}
      {id: 'pmc19', nome: 'PMC 19%'}
      {id: 'pmc17ZonaFranca', nome: 'PMC 17% Zona Franca de Manaus'}
    ]

  getColumnName: (identificador) ->
    return item.nome for item in @listOfColuna when item.id == identificador

  modalResolve: (item) ->
    {
      item: => if item? then angular.copy(item) else {estado: @filtro.estado}
      listOfEstado: => @listOfEstado
      listOfColuna: => @listOfColuna
    }

angular.module('eficienciaFiscalModule').controller('medicamentoConfiguracaoAnvisaController', MedicamentoConfiguracaoAnvisaController)

class MedicamentoConfiguracaoAnvisaModalController extends AbstractController
  @$inject = [ '$injector', '$uibModalInstance', 'medicamentoConfiguracaoAnvisaService', 'item', 'listOfEstado', 'listOfColuna' ]

  constructor: ($injector, @modalInstance, @medicamentoConfiguracaoAnvisaService, @item, @listOfEstado, @listOfColuna) ->
    super($injector)

    @submitTracker = @promiseTracker()

  salvar: (form) ->
    if form.$valid
      @submitTracker.addPromise @medicamentoConfiguracaoAnvisaService.save(@item, (data) =>
        Alert.success("Configuração para o estado de <strong>#{@item.estado.nome}</strong> #{if @item.id then 'atualizada' else 'criada'} com sucesso.", 'Sucesso!')
        @modalInstance.close(new Retorno(true, null, data))
      )

angular.module('eficienciaFiscalModule').controller('medicamentoConfiguracaoAnvisaModalController', MedicamentoConfiguracaoAnvisaModalController)